<template>
    <div>
        <Row :gutter="12">
            <div class="w-full flex justify-end">
                <div class="mr-2">
                    <p>Filtrar por vendedor</p>
                    <i-select filterable v-model="filters.salerId" clearable @on-clear="() => filters.salerId = 0" @on-change="loadChart" class="w-64" :disabled="filters.companyId !== 0">
                        <Option v-for="saler in salers" :value="saler.value" :key="saler.value">{{ saler.label }}</Option>
                    </i-select>
                </div>
                <div class="mr-2">
                    <p>Filtrar por Atividades</p>
                    <i-select filterable v-model="filters.activityName" clearable @on-clear="() => filters.activityName = ''" @on-change="loadChart" class="w-64">
                        <Option v-for="activity in activities" :value="activity.label" :key="activity.value">{{ activity.label }}</Option>
                    </i-select>
                </div>
            </div>
        </Row>
        <Spin size="large" fix v-if="chart.metadata.loading"></Spin>
        <echart :options="chart.options" @click="getCustomersByStatus"></echart>
        <div v-show="metadata.showTable">
            <div @scroll="loadMoreCompanies" class="overflow-auto h-auto" style="max-height:32rem;">
                <i-table ref="table" :columns="table.columns" :data="table.data" :loading="metadata.loading"/>
            </div>
            <br />
            <span class="mt-2"> Exibindo {{metadata.page + 1}}-{{Math.floor(metadata.companiesNumber / config.companiesNumberPerPage) + 1}} de {{metadata.companiesNumber}}</span>
        </div>
    </div>
</template>

<script>
import clienteMixin from './Mixins/ClienteMixin';
import { revendaApi } from "@/api/axios";

export default {
    mixins: [clienteMixin],
    name: 'segmentos',
    data () {
        return {
            activityName: '',
            config: {
                status: 'segmentos'
            },
            table: {
                columns: [
                    {
                        title:'#',
                        key:'clienteId',
                        sortable:true,
                        width: 100
                    },
                    {
                        title:'Cliente',
                        key:'nome',
                        sortable:true,
                        minWidth: 250
                    },
                    {
                        title:'Cliente desde',
                        key:'data_pessoa_cadastro',
                        sortable:true,
                        minWidth: 150,
                        render: (h, params) => {
                            return h('p', this.formatDate(params.row.data_pessoa_cadastro))
                        }
                    },
                    {
                        title: 'Vendedor',
                        key: 'vendedor_nome',
                        sortable: true,
                        minWidth: 200
                    }
                ]
            }
        }
    },

    methods: {
        async loadChart()
        {
            this.clearMetadata();

            const segments = await this.getChart("segments");
            const data = _.orderBy(segments, ['total'], ['desc']).slice(0, 20).map(segment => ({value: segment.total, name: (segment.segmento_empresa || 'Não informado')}));
            this.chart.options.tooltip = {
                type: 'shadow',
                formatter:(params, ticket, callback)=>{
                    return `${params.data.name}: ${params.data.value}`;
                }
            }
            this.chart.options.xAxis = [
                {
                    type : 'category',
                    data : data.map(segment => segment.name),
                    axisLine: {onZero: true},
                    splitLine: {show: false},
                    splitArea: {show: false},
                }
            ];

            this.chart.options.legend = {
                data: [{name: 'Atividades', alias: 'segments'}]
            };
            this.chart.options.series = [
                {
                    name: 'Atividades',
                    type: 'bar',
                    color: '#20B2AA',
                    stack: 'clientes',
                    data:data,
                    label: {
                        normal:{
                            position:'inside',
                            show:true,
                            color:'#ffffff',
                        },
                    },
                }
            ];

            this.chart.metadata.loading = false;
        },
        async getChartData (segment, status, page) {
            const {data} = await revendaApi.get('stats/companies', {
                params: {
                    status: status, page: page, segment, saler_id: this.filters.salerId,
                    company_id: this.filters.companyId
                }
            });
            return this.defaultingChartData(data);
        }
    }
}
</script>

<style scoped>

</style>
